import { Tracker } from 'services/tracking';
import { HOSTED_PAGE_TYPES, GA_ACTIONS } from 'consts';

export const trackSetDefault = () => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardTokenization);
  tracker.fireEvent({
    category: GA_ACTIONS.SET_DEFAULT,
    action: GA_ACTIONS.SET_DEFAULT
  });
};

export const trackSaveCard = status => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardTokenization);
  tracker.fireEvent({
    category: GA_ACTIONS.SAVE_CARD,
    action: GA_ACTIONS.SAVE_CARD,
    label: status
  });
};
